import { render, staticRenderFns } from "./StockStatusLabel.vue?vue&type=template&id=761d960b&scoped=true&"
import script from "./StockStatusLabel.vue?vue&type=script&lang=js&"
export * from "./StockStatusLabel.vue?vue&type=script&lang=js&"
import style0 from "./StockStatusLabel.vue?vue&type=style&index=0&id=761d960b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761d960b",
  null
  
)

export default component.exports